import { AutoComplete, Input } from 'antd';
import { useState } from 'react';
import { useIntl } from 'react-intl';
import { shallowEqual, useSelector } from 'react-redux';
import { Link, useHistory } from 'react-router-dom';
import { LicenseType } from '../../../interface';
import { HibraryRootState } from '../../../redux/rootReducer';
import {
  fetchAutocomplete,
  saveSearchAutoComplete,
  saveSearchAutoCompletePublic,
  SearchType,
  AutoCompleteMetaData,
  CategoryAutoCompleteMetaData,
  AutoCompleteKey
} from '../../redux/search/action';
import {
  getPublisherRoute,
  getDetailRoute,
  getListSubCategoryRoute,
  getWriterRoute,
  getSearchRoute
} from '../../routes/generatePath';
import './index.scss';

const SearchBox = () => {
  const intl = useIntl();
  const history = useHistory();
  const [options, setOption] = useState<any[]>();
  const [isLoading, setIsLoading] = useState(false);

  const { clientInfo, authState } = useSelector(
    (state: HibraryRootState) => ({
      authState: state.auth,
      clientInfo: state.clientInfo
    }),
    shallowEqual
  );

  const renderTitle = (title: string) => (
    <div className="autocomplete-header">
      <p style={{ marginBottom: 0 }}>{title}</p>
    </div>
  );

  const onLinkClick = async (keyword: string) => {
    setOption(undefined);
    if (authState.isLogin) {
      saveSearchAutoComplete(keyword);
    } else {
      saveSearchAutoCompletePublic(keyword, clientInfo.companyPrefix);
    }
  };

  const renderItem = (title: string, key?: string, link?: string) => ({
    value: title,
    label: (
      <Link to={link ?? ''} onClick={() => onLinkClick(title)}>
        <div key={key} className="autocomplete-item">
          {title}
        </div>
      </Link>
    )
  });

  const onChange = async (el: string) => {
    try {
      if (el.length > 3) {
        setIsLoading(true);
        const result = await fetchAutocomplete(
          el,
          clientInfo.companyPrefix,
          authState.isLogin
        );
        const optionConvert = createSearchAutoComplete(result! as any);
        setOption(optionConvert);
      } else {
        setOption([]);
      }
    } catch (error) {
      setOption([]);
    }
    setIsLoading(false);
  };

  const getAutocompleteLink = (
    data: AutoCompleteMetaData | CategoryAutoCompleteMetaData,
    licenseType: LicenseType = LicenseType.Rent
  ) => {
    console.log(data, licenseType);

    switch (data.type) {
      case SearchType.AUTHOR:
        return getWriterRoute(data.uid, licenseType);
      case SearchType.KEYWORD:
        return getSearchRoute(data.keyword);
      case SearchType.TITLE:
        return getDetailRoute(data.uid, data.contentType, licenseType);
      case SearchType.PUBLISHER:
        return getPublisherRoute(data.uid, licenseType);
      case SearchType.CATEGORY: {
        const getData = data as CategoryAutoCompleteMetaData;
        return getListSubCategoryRoute(
          getData.uid,
          getData.subcategoryUID,
          licenseType,
          getData.contentType
        );
      }
      default:
        return getDetailRoute(data.uid, data.contentType, licenseType);
    }
  };

  const getSegmentTitle = (title: string) => {
    switch (title) {
      case 'author': {
        return 'นักเขียน';
      }
      case 'title': {
        return 'ชื่อ';
      }
      case 'publisher': {
        return 'สำนักพิมพ์';
      }
      case 'category': {
        return 'หมวดหมู่';
      }
      case 'keyword': {
        return 'คำสำคัญ';
      }
      default:
        return '';
    }
  };

  const createSearchAutoComplete = (result: {
    [x: string]: AutoCompleteKey[];
  }): any[] => {
    const finalData: any[] = [];
    for (const key in result) {
      const value = result[key];

      const title = renderTitle(getSegmentTitle(key));
      const options: any[] = [];
      value.forEach((el: any) => {
        switch (key) {
          case 'category': {
            const data = el as CategoryAutoCompleteMetaData;
            options.push(
              renderItem(data.keyword, data.uid, getAutocompleteLink(data))
            );
            break;
          }
          default: {
            const data = el as AutoCompleteMetaData;
            options.push(
              renderItem(
                data.keyword,
                data.uid,
                getAutocompleteLink(data, el.licenseType)
              )
            );
          }
        }
      });

      if (options.length > 0) {
        finalData.push({
          label: title,
          options: options
        });
      }
    }

    return finalData;
  };

  return (
    <div className="search">
      <AutoComplete
        className="nav-search-autocomplete"
        dropdownClassName="certain-category-search-dropdown"
        showSearch={true}
        options={options}
      >
        <Input.Search
          size="middle"
          className="nav-search-bar"
          loading={isLoading}
          onChange={(el) => onChange(' ' + el.target.value)}
          placeholder={intl.formatMessage({
            id: 'Search.Title'
          })}
          onSearch={(el) => {
            if (el.length > 0) history.push(`/search/${el.trim()}`);
          }}
          allowClear
        />
      </AutoComplete>
    </div>
  );
};

export default SearchBox;
